import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/database';
import { config } from './config';

let firebaseInstance = null;

function getFirebase() {
  if (firebaseInstance) {
    return firebaseInstance;
  }

  try {
    firebaseInstance = firebase.initializeApp(config);
    firebase.analytics();
  } catch (err) {
    if (err.code === 'app/duplicate-app') {
      firebaseInstance = firebase.app(); // If already initialized, use that one
    } else {
      console.error('Firebase initialization error', err.stack);
    }
  }

  return firebaseInstance;
}

const app = getFirebase();
export default app; 